import {makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    fileUploadEdit: {
        width: "100%",
        display:"flex",
    },
    fileUploadView: {
        width: "100%",
        display:"flex",
    },
    fileNameLbl: {
        color: "#767676",
        fontSize: "14px",
        fontWeight: "bold",
        width: "60%",
        paddingTop: "10px",
    },
    btnGroup: {
        width: "40%",
        textAlign: "right",
    },
    fileNameInput: {
        width: "100%",
        textAlign:"left",
        "& .form-control": {
          },
        "& .MuiIconButton-root": {
            padding: "5px !important",
            marginTop: "8px",
        },
        "& .MuiSvgIcon-root": {
            color: "#ffffff !important",
            height: "20px !important",
            width: "20px !important",
        },
    },
    textWrapInput: {
        float: "left",
        textAlign: "left",
        fontSize: "14px",
        width: "75% !important",
        margin: "0px 5px 0 0",
        border: "1px solid #ddd",
        borderRadius: "4px",
        padding: "10px 0 10px 2px",
        minHeight: "20px",
        cursor: "pointer"
      },
    fileUploadDetails: {
        width: "100%",
        textAlign:"left",
        "& .MuiIconButton-root": {
            padding: "5px !important",
            marginRight: "6px",
            marginTop: "8px",
        },
        "& .MuiSvgIcon-root": {
            color: "#ffffff !important",
            height: "20px !important",
            width: "20px !important",
        },
    },
}));

export default  useStyles;